import {ButtonRaw} from '@/components/Button';
import {BinIcon} from '@/components/Icons';
import {StickyHeader} from '@/components/Layout';
import pushContentTypes from '@/consts/inbox/pushContentTypes';
import {
    INBOX_DELETE_MESSAGE_BUTTON_ARIA_LABEL,
    NOTIFICATION_DETAILS_PAGE_HEADER_TITLE,
} from '@/consts/localization/localizationKeys';
import {NotificationDetailsMessage} from '@/containers/Inbox/NotificationDetails/components/NotificationDetailsMessage';
import useMessageDeletionWithUndo from '@/hooks/inbox/useMessageDeletionWithUndo';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import {getAriaLabel} from '@/services/accessibilityService';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import {twx} from '@/utils/tailwindUtils';

import NotificationDetailsReadNext from './components/NotificationDetailsReadNext';

const NotificationDetails = ({message, nextMessage, onBackButtonClick}) => {
    const isMobile = useIsMobileLayout();
    const localizedStrings = getLocalizedStrings();
    const {messageId, title, pushContentType} = message || {};
    const isLoyaltyPushContentType = pushContentTypes.isPushContentTypeLoyalty(pushContentType);
    const isDark = isLoyaltyPushContentType;

    const handleMessageDeleteClick = useMessageDeletionWithUndo({messageId});
    const onDeleteClick = () => {
        handleMessageDeleteClick();
        onBackButtonClick();
    };

    return (
        <div className='flex flex-col bg-secondary text-start'>
            {isMobile && (
                <StickyHeader
                    isDark={isDark}
                    onBack={onBackButtonClick}
                    endIcon={
                        <ButtonRaw
                            onClick={onDeleteClick}
                            aria-label={getAriaLabel(INBOX_DELETE_MESSAGE_BUTTON_ARIA_LABEL)}
                        >
                            <BinIcon />
                        </ButtonRaw>
                    }
                    title={localizedStrings.formatString(
                        localizedStrings[NOTIFICATION_DETAILS_PAGE_HEADER_TITLE],
                        title
                    )}
                />
            )}
            {message && (
                <NotificationDetailsMessage
                    className={twx(
                        'px-layout pt-safe-offset-sticky-header grow pb-2',
                        isDark ? 'bg-primary-dark text-romance' : 'bg-romance'
                    )}
                    isDark={isDark}
                    onDeleteClick={onDeleteClick}
                    {...message}
                />
            )}
            {nextMessage && <NotificationDetailsReadNext notificationItem={nextMessage} />}
        </div>
    );
};

export default NotificationDetails;
